import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import Header from '../layout/Header';
import { connect, useDispatch } from 'react-redux';
import { applicationDetail } from '../../actions/v3/applicationDetail';
import { Link } from 'react-router-dom';

function ConcludedApplicationDetail(props) {

    const { Id } = useParams();
    const dispatch = useDispatch();
    const IsDoctor = localStorage.getItem("IsDoctor") ? localStorage.getItem("IsDoctor") : false;

    useEffect(() => {
        dispatch(applicationDetail(Id))
    }, [dispatch])


    return (
        <div>
            <Header />
            <div className='pt-10 md:ml-64 ps-5'>
                <ol className="flex items-center whitespace-nowrap min-w-0" aria-label="Breadcrumb">
                    <li className="text-sm">
                        <Link to="/applicationsv2"
                            className="flex items-center text-gray-500 hover:text-[#09C35C]" href="#">
                            Başvurularım
                            <svg className="flex-shrink-0 mx-3 overflow-visible h-2.5 w-2.5 text-gray-400 dark:text-gray-600" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                        </Link>
                    </li>
                    <li className="text-sm font-semibold text-gray-800 truncate dark:text-gray-200" aria-current="page">
                        Başvuru Detayı
                    </li>
                </ol>
            </div>
            <hr className='divide-y mt-2' />
            {props.applicationDetail.done ?
                <div className='md:ml-64 ps-10 pe-5 mt-10'>
                    <h1 className='text-2xl text-start mb-5'>Başvuru sonucunuz</h1>
                    <iframe frameborder="0" width="100%" height="900" src={props.applicationDetail.applicationDetail.result.results[0].result} alt="" />
                </div>
                :
                <div className='mt-5 ps-5 pe-5 md:ml-64 text-start'>
                    <div className="relative">
                        <div style={{ backgroundColor: `#09c35d7c` }} className="bg-blue-50 border border-blue-200 rounded-md p-4">
                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <i className="fa-light fa-file"></i>
                                </div>
                                <div className="ml-3">
                                    <h3 className="text-sm text-blue-800 font-medium">
                                        Detay yükleniyor
                                    </h3>
                                    <div className="text-sm text-blue-700 mt-2">
                                        <span className="font-semibold">Lütfen bekleyin!</span> Başvurunuzun detayı yükleniyor.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="absolute top-0 left-0 w-full h-full bg-white/[.5] rounded-md dark:bg-gray-800/[.4]"></div>
                        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                            <div className="animate-spin inline-block w-6 h-6 border-[3px] border-current border-t-transparent text-blue-600 rounded-full" role="status" aria-label="loading">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>

            }


        </div >
    )
}



const mapStateToProps = (state) => {
    return state;
};
const mapDispatchToProps = {
};
export default connect(mapStateToProps, mapDispatchToProps)(ConcludedApplicationDetail);